import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=a90709bc"
import script from "./copyright.vue?vue&type=script&lang=js"
export * from "./copyright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports